module.exports = __webpack_public_path__ + "static/media/facebook.8afd3780.svg";